import { useNavigate } from 'react-router-dom'
import { Tile, Layer } from '@carbon/react'
import { Trophy } from '@carbon/icons-react'
import {
  formatAnalyticsPercentOneDecimal,
  formatShortId,
} from '@sphere/shared/util'
import styles from './PersonalTopActivities.module.scss'

export interface TopActivity {
  activityId: string
  activityTitle?: string
  avgScore: number
  totalAttempts: number
  successRate: number
}

export interface PersonalTopActivitiesProps {
  activities: TopActivity[]
}

export function PersonalTopActivities({
  activities,
}: PersonalTopActivitiesProps) {
  const navigate = useNavigate()

  if (!activities || activities.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>Aucune activité disponible sur la période sélectionnée.</p>
      </div>
    )
  }

  return (
    <Layer className={styles.wrapper}>
      <Tile className={styles.tile}>
        <div className={styles.header}>
          <Trophy size={20} className={styles.headerIcon} />
          <h3 className={styles.title}>Top Activités</h3>
        </div>
        <ul className={styles.list}>
          {activities.map((activity, index) => (
            <li
              key={activity.activityId}
              className={styles.item}
              role="button"
              tabIndex={0}
              onClick={() =>
                navigate(`/learning/activities/${activity.activityId}`)
              }
              onKeyDown={e =>
                (e.key === 'Enter' || e.key === ' ') &&
                navigate(`/learning/activities/${activity.activityId}`)
              }
            >
              <div
                className={`${styles.rank} ${index === 0 ? styles.rankTop : ''}`}
              >
                {index + 1}
              </div>
              <div className={styles.content}>
                <p className={styles.activityName}>
                  {activity.activityTitle ||
                    `Activité ${formatShortId(activity.activityId)}`}
                </p>
                <p className={styles.meta}>
                  {activity.totalAttempts} tentative
                  {activity.totalAttempts > 1 ? 's' : ''}
                </p>
              </div>
              <div className={styles.scoreWrapper}>
                <span className={styles.scoreValue}>
                  {formatAnalyticsPercentOneDecimal(activity.avgScore)}
                </span>
                <div className={styles.scoreBar}>
                  <div
                    className={styles.scoreBarFill}
                    style={{ width: `${Math.min(activity.avgScore, 100)}%` }}
                  />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </Tile>
    </Layer>
  )
}
